<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Entegresyon Dosyası İndir</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field> -->


              <!--
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu> -->



            </v-toolbar>
          </v-flex>



          <v-container fluid="">
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 sm4 md2>
                  <v-menu :close-on-content-click="true" v-model="menu" transition="scale-transition" offset-y
                    full-width :nudge-right="40" min-width="290px">
                    <v-text-field slot="activator" label="Başlangıç Tarihi" v-model="dateFormatted" append-icon="event"
                      v-on:change="onChange" mask="##.##.####" @blur="date = parseDate(dateFormatted)" data-vv-name="tarihsec"
                      :error-messages="errors.collect('tarihsec')" v-validate="'required'" required></v-text-field>
                    <v-date-picker locale="tr" v-model="date" @input="dateFormatted = formatDate($event)" no-title
                      scrollable actions>
                      <v-spacer></v-spacer>
                    </v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm4 md2>
                  <v-menu :close-on-content-click="true" v-model="menu2" transition="scale-transition" offset-y
                    full-width :nudge-right="40" min-width="290px">
                    <v-text-field slot="activator" label="Bitiş Tarihi" v-model="dateFormatted2" append-icon="event"
                      v-on:change="onChange2" mask="##.##.####" @blur="date2 = parseDate2(dateFormatted2)" data-vv-name="tarihsec1"
                      :error-messages="errors.collect('tarihsec1')" v-validate="'required'" required></v-text-field>
                    <v-date-picker locale="tr" v-model="date2" @input="dateFormatted2 = formatDate2($event)" no-title
                      scrollable actions>
                      <v-spacer></v-spacer>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <v-layout align-center justify-center row fill-height>
                    <v-radio-group v-model="tip" row>
                      <v-radio label="Bilet" value="0"></v-radio>
                      <v-radio label="Fatura" value="1"></v-radio>
                      <v-radio label="İade" value="2"></v-radio>
                    </v-radio-group>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm1 md1>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList()" fab small="" dark>
                        <v-icon>save_alt</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="load">
                      <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <v-layout row="" wrap>
              <v-flex xs12 sm12 md12>

                <span v-if="!load1"> Dosyanız İndiriliyor. Lütfen Bekleyiniz...</span>

                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                  :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                  {{ text1 }}
                  <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>

      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        tip: '0',
        search: '',
        headers: [{
            text: 'Cari Kod',
            value: 'Current'
          },
          {
            text: 'Ünvan',
            value: 'CurrentTitle'
          },
          {
            text: 'Tarih',
            value: 'Date'
          },
          {
            text: 'Evrak Tipi',
            value: 'DocumentType'
          },
          {
            text: 'Evrak No',
            value: 'DocumentNumber'
          },
          {
            text: 'Açıklama',
            value: 'Explanation'
          },
          {
            text: 'Vade Tarihi',
            value: 'DueDate'
          },
          {
            text: 'Borç',
            value: 'Debt'
          },
          {
            text: 'Alacak',
            value: 'Credit'
          },
          {
            text: 'Bakiye',
            value: 'Balance'
          },
          {
            text: 'B/A',
            value: 'BAType'
          }
        ],




        StartDate: null,
        EndDate: null,
        statecari: [],
        searchcari: '',
        progress: false,

        renk1: 'info',
        dialogfiltre: false,


        dictionary: {
          custom: {
            masrafkodu: {
              required: () => 'Lütfen seçiminizi yapınız'
            },
            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },

        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
      }
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)


    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    methods: {
      formatDate(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      formatDate2(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      parseDate(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {
          console.log('')
        } else if (n == -1 && m != 8) {
          this.dateFormatted = getDateNow1()
          this.date = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      parseDate2(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {
          console.log('')
        } else if (n == -1 && m != 8) {
          this.dateFormatted2 = getDateNow1()
          this.date2 = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      onChange: onChange,
      onChange2: onChange2,
      filtrele: filtrele,
      carigetir: carigetir
    }
  }



  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', {}, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/doctype/List', {}, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

  }





  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }


  function getList() {

    this.$validator.validateAll().then((result) => {

      if (result) {

        var bastarih = new Date(this.date)
        var bittarih = new Date(this.date2)

        if (bastarih <= bittarih) {


          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          this.load1 = false


          var params = {
            SirketKodu: credentials.SirketKodu,
            BaslangicTarih: this.date,
            BitisTarih: this.date2
          }

          if (this.tip == '0') {

            this.$http.post(auth.API_URL + 'api/TicketIntegration/DownloadTicketIntegration', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              var blob = new Blob([response.data], {
                type: 'application/xml'
              });
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = "bilet_entegrasyon.xml";
              link.click();
              this.load1 = true
            }, (response) => {
              if (response.status === 0) {
                this.text = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false
              } else {
                this.text = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false

              }
            })

          } else if (this.tip == '1') {
            this.$http.post(auth.API_URL + 'api/TicketIntegration/DownloadInvoiceIntegration', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              var blob = new Blob([response.data], {
                type: 'application/xml'
              });
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = "fatura_entegrasyon.xml";
              link.click();
              this.load1 = true
            }, (response) => {
              if (response.status === 0) {
                this.text = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false
              } else {
                this.text = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false

              }
            })
          }  else if (this.tip == '2') {


          var params1 = {
            SirketKodu: credentials.SirketKodu,
            BaslangicTarihi: this.date,
            BitisTarihi: this.date2
          }

            this.$http.post(auth.API_URL + 'api/TicketIntegration/DownloadRefundIntegration', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              var blob = new Blob([response.data], {
                type: 'application/xml'
              });
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = "iade_entegrasyon.xml";
              link.click();
              this.load1 = true
            }, (response) => {
              if (response.status === 0) {
                this.text = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false
              } else {
                this.text = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false

              }
            })
          }

        } else {
          this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
          this.snackbar = true
        }
      }
    })


  }

  function getListHtml() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.progress = true
    this.currentDebtTotal = 0
    this.currentCreditTotal = 0
    this.debtTotal = 0
    this.creditTotal = 0
    this.load1 = false

    if (this.date == null) {
      this.date = getDateNow()
    }

    if (this.date2 == null) {
      this.date2 = getDateNow()
    }

    console.log(this.secilenevraklar + 'secilen evraklar')


    if (this.secilenevraklar.length > 0) {
      this.secilenevraklar.forEach(element => {
        var evrak = {
          EvrakKod: element
        }
        this.Ekstreinput.Evraklar.push(evrak)
      });

    }

    this.Ekstreinput.BaslangicTarih = this.date
    this.Ekstreinput.BitisTarih = this.date2

    if (this.tumsirketler === true) {
      this.Ekstreinput.SirketKodu = 0
    } else {
      this.Ekstreinput.SirketKodu = credentials.SirketKodu
    }


    var params = this.Ekstreinput




    this.$http.post(auth.API_URL + 'api/Abstract/ListWithoutCurrentHtml', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.load = false
      this.load1 = true
      this.progress = false
      var blob = new Blob([response.data], {
        type: 'application/html'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "TarihEkstre.html";
      link.click();

    }, (response) => {
      if (response.status === 0) {
        this.text = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false

      } else {
        this.text = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false

      }
    })
  }

  function getListExcel() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.progress = true
    this.currentDebtTotal = 0
    this.currentCreditTotal = 0
    this.debtTotal = 0
    this.creditTotal = 0
    this.load1 = false

    if (this.date == null) {
      this.date = getDateNow()
    }

    if (this.date2 == null) {
      this.date2 = getDateNow()
    }

    console.log(this.secilenevraklar + 'secilen evraklar')


    if (this.secilenevraklar.length > 0) {
      this.secilenevraklar.forEach(element => {
        var evrak = {
          EvrakKod: element
        }
        this.Ekstreinput.Evraklar.push(evrak)
      });

    }

    this.Ekstreinput.BaslangicTarih = this.date
    this.Ekstreinput.BitisTarih = this.date2

    if (this.tumsirketler === true) {
      this.Ekstreinput.SirketKodu = 0
    } else {
      this.Ekstreinput.SirketKodu = credentials.SirketKodu
    }


    var params = this.Ekstreinput




    this.$http.post(auth.API_URL + 'api/Abstract/ListWithoutCurrentExcel', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      },
      responseType: "arraybuffer"
    }).then((response) => {
      this.load = false
      this.load1 = true
      this.progress = false
      var blob = new Blob([response.data], {
        type: 'application/xlsx'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "TarihEkstre.xlsx";
      link.click();

    }, (response) => {
      if (response.status === 0) {
        this.text = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false

      } else {
        this.text = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false

      }
    })
  }



  function beforeMount() {
    this.dateFormatted = getDateNow1()
    this.date = getDateNow()
    this.dateFormatted2 = getDateNow1()
    this.date2 = getDateNow()
  }




  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      var ay = a[2] + a[3]
      var gun = a[0] + a[1]
      var yil = a[4] + a[5] + a[6] + a[7]

      a = new Date(b)

      if (a instanceof Date && !isNaN(a.valueOf())) {
        //şubatın 29 çekmesin
        if (ay == '02' && yil % 10 != 0 && gun == '29') {

          b = yil + '-' + ay + '-' + '28'
          this.date = b
          this.dateFormatted = '28' + '-' + ay + '-' + yil
          //31 nisan
        } else if (ay == '04' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 haziran
        } else if (ay == '06' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 eylül
        } else if (ay == '09' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 kasım
        } else if (ay == '11' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil

        } else {
          this.date = b
        }
      } else {
        this.dateFormatted = null

      }
    } else {
      this.dateFormatted = null
    }
  }

  function onChange2(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      var ay = a[2] + a[3]
      var gun = a[0] + a[1]
      var yil = a[4] + a[5] + a[6] + a[7]

      a = new Date(b)
      if (a instanceof Date && !isNaN(a.valueOf())) {
        //şubatın 29 çekmesi
        if (ay == '02' && yil % 10 != 0 && gun == '29') {

          b = yil + '-' + ay + '-' + '28'
          this.date2 = b
          this.dateFormatted2 = '28' + '-' + ay + '-' + yil
          //31 nisan
        } else if (ay == '04' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 haziran
        } else if (ay == '06' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 eylül
        } else if (ay == '09' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 kasım
        } else if (ay == '11' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil

        } else {
          this.date2 = b
        }
      } else {
        this.dateFormatted2 = null
      }
    } else {
      this.dateFormatted2 = null
    }
  }

  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }
</script>

<style>
</style>